import React from 'react'
import "./About_why_choose_us.css"
import Common_heading from '../../common_component/common_heading/Common_heading'
import About_why_choose_us_card from './about_why_choose_us_card/About_why_choose_us_card'

function About_why_choose_us() {
    return (
        <>
            <section className='About_why_choose_us'>
                <div className="container">
                    <Common_heading title="Why Choose Us ?" subTitle="Trusted Sourcing. Tailored Solutions. Seamless Delivery." />
                    <div className="cards_holder">
                        <div className="row justify-content-center">
                            <div className="col-xl-4 col-md-4 col-sm-6 mb-5">
                                <About_why_choose_us_card text1="Dubai-Based, " text2="Global Reach" imgSrc="/assets/images/about_us/about_why_choose_us/about_why_choose_us_card/network.png" description="Strategically headquartered in Dubai to connect international suppliers with emerging markets." />
                            </div>

                            <div className="col-xl-4 col-md-4 col-sm-6 mb-5">
                                <About_why_choose_us_card text1="Trusted FMCG " text2="Sourcing" imgSrc="/assets/images/about_us/about_why_choose_us/about_why_choose_us_card/badge.png" description="We source high-quality food, beverages, and spirits through a reliable global network." />
                            </div>

                            <div className="col-xl-4 col-md-4 col-sm-6 mb-5">
                                <About_why_choose_us_card text1="Tailored For " text2="African Markets" imgSrc="/assets/images/about_us/about_why_choose_us/about_why_choose_us_card/shopping-bag.png" description="Deep understanding of regional needs in countries like Rwanda, Uganda, and DR Congo." />
                            </div>

                            <div className="col-xl-4 col-md-4 col-sm-6 mb-5">
                                <About_why_choose_us_card text1="Timely Delivery " text2="Transparent Process" imgSrc="/assets/images/about_us/about_why_choose_us/about_why_choose_us_card/time.png" description="Efficient logistics and clear communication from order to delivery." />
                            </div>

                            <div className="col-xl-4 col-md-4 col-sm-6 mb-5">
                                <About_why_choose_us_card text1="Competitive Pricing, " text2="Premium Quality" imgSrc="/assets/images/about_us/about_why_choose_us/about_why_choose_us_card/best-price.png" description="Offering the best value without compromising on quality or standards" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About_why_choose_us